var map = {
	"./1.svg": "3296",
	"./Steor-Icons-01.svg": "5269",
	"./Steor-Icons-02.svg": "16a9",
	"./Steor-Icons-03.svg": "f177",
	"./Steor-Icons-04.svg": "4cfa",
	"./Steor-Icons-05.svg": "dc37",
	"./Steor-Icons-06.svg": "51ff",
	"./Steor-Icons-07.svg": "cd4d",
	"./Steor-Icons-08.svg": "d0e1",
	"./Steor-Icons-09.svg": "1505",
	"./Steor-Icons-10.svg": "1bce",
	"./Steor-Icons-11.svg": "116c",
	"./Steor-Icons-12.svg": "24f3",
	"./Steor-Icons-13.svg": "61bc",
	"./Steor-Icons-14.svg": "f42f",
	"./Steor-Icons-15.svg": "d0ca",
	"./Steor-Icons-16.svg": "c638",
	"./Steor-Icons-17.svg": "fadf",
	"./Steor-Icons-18.svg": "2558",
	"./Steor-Icons-19.svg": "55ce",
	"./Steor-Icons-20.svg": "1d26",
	"./Steor-Icons-21.svg": "48f9",
	"./Steor-Icons-22.svg": "cf53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f56";